// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__3MoXR","contact__head":"contact_contact__head__u6+pj"};